import { DocumentoTipoRequisito, eEstadoDocumento, SolicitudSeccion } from "../common/enumModel";
import { IConfiguracionDocumentoCreateModel } from "../interfaces/configuracion-documento/IConfiguracionDocumentoCreateModel";

export class ConfiguracionDocumentoCreateModel implements IConfiguracionDocumentoCreateModel {
    idMaestroDocumento: number;
    idTipoVisita: number;
    idRequisito : DocumentoTipoRequisito;
    esPredeterminado: boolean;
    controlarFechas: boolean;
    restringeAccesos: boolean;
    seccion: SolicitudSeccion;
    idEstado: eEstadoDocumento;

    constructor(){
        this.idMaestroDocumento = 0;
        this.idTipoVisita = 0;
        this.idRequisito = DocumentoTipoRequisito.TODOS;
        this.esPredeterminado = false;
        this.controlarFechas = false;
        this.restringeAccesos = false;
        this.seccion = SolicitudSeccion.Personal;
        this.idEstado = eEstadoDocumento.ACTIVO;
    }
}